import { defineNuxtRouteMiddleware, navigateTo } from 'nuxt/app'
import { useRegistrationStore } from '~/stores/registration'

export default defineNuxtRouteMiddleware((to) => {
  if (import.meta.server) {
    const registrationStore = useRegistrationStore()

    if (to.name === 'registreren-maaltijdzoeker-check') {
      if (!registrationStore.formProgress.foodie.isConfirmStep) {
        return navigateTo({
          name: 'registreren-maaltijdzoeker'
        })
      } else if (registrationStore.formProgress.foodie.hasSubmitted) {
        return navigateTo({
          name: 'registreren-bedankt-maaltijdzoeker-municipality',
          params: {
            municipality: registrationStore.formProgress.foodie.municipality ?? 'onbekend'
          }
        })
      }
    }

    if (
      to.name === 'registreren-maaltijdzoeker' &&
      registrationStore.formProgress.foodie.hasSubmitted
    ) {
      return navigateTo({
        name: 'registreren-bedankt-maaltijdzoeker-municipality',
        params: {
          municipality: registrationStore.formProgress.foodie.municipality ?? 'onbekend'
        }
      })
    }

    if (
      to.name === 'registreren-bedankt-maaltijdzoeker-municipality' &&
      !registrationStore.formProgress.foodie.hasSubmitted
    ) {
      if (registrationStore.formProgress.foodie.isConfirmStep) {
        return navigateTo({
          name: 'registreren-maaltijdzoeker-check'
        })
      } else {
        return navigateTo({
          name: 'registreren-maaltijdzoeker'
        })
      }
    }
  } else if (import.meta.client) {
    const registrationStore = useRegistrationStore()

    if (to.name === 'registreren-maaltijdzoeker-check') {
      if (!registrationStore.foodie.contactStep.gender) {
        return navigateTo({
          name: 'registreren-maaltijdzoeker'
        })
      }
    }
  }
})
